export default __webpack_public_path__ + "b057e72188e88bb9dc40f20d707000c5.svg";